module.exports = __webpack_public_path__ + "static/media/01A.d70fedec.png";